export default __webpack_public_path__ + "static/media/RER_A.44ce1c5d.png";